export default {
  welcome: {
    your_language: 'Ваш язык',
    language_to_learn: 'Язык, который вы хотите изучить',
    start_learning: 'Начать обучение',
    how_does_this_work: 'Как это работает?',
    welcome_1: 'Добро пожаловать в JAALUU',
    welcome_2: 'Здесь вы можете изучать языки',
    welcome_3: 'Читать тексты или смотреть видео с субтитрами',
    welcome_4: 'Нажимайте на слово для перевода, примеров и определений',
    main_teaser: 'Улучшайте свои языковые навыки — легко и бесплатно',
    hero_headline: 'Хватит зубрить списки слов. Начните говорить свободно с ИИ-погружением',
    hero_subheadline:
      'Jaaluu использует реальный контент, персонализированные разговоры с чат-ботом и интервальное повторение, чтобы помочь вам освоить новый язык за несколько минут в день.',
    hero_cta: 'Начать бесплатно',
    select_language_and_start: 'Выберите язык и начните',
    how_to_title: 'Читайте тексты, книги, новости или смотрите видео',
    how_to_text: 'Вы можете выбрать из различных текстов, книг, новостей или видео',
    click_on_word_title: 'Автоматический перевод, примеры и определения',
    click_on_word_text:
      'Нажмите на любое слово, чтобы получить автоматический перевод, примеры предложений и определения. Вы также можете переводить целые предложения автоматически или связывать слова с изображениями и создавать словесные сети.',
    listen_title: 'Слушайте слова и тексты',
    listen_text:
      'Вы можете слушать любое слово, предложение или целые тексты и тренировать произношение',
    conversations_title: 'Практикуйте разговоры',
    conversations_text:
      'Вы можете практиковать разговоры, общаясь с виртуальным чат-ботом. Вам нужно решать задачи, такие как: `Заказать еду в ресторане` или `Попросить указания.`',
    writing_title: 'Правописание',
    writing_text_1: 'Практикуйте правописание, написав тексты',
    writing_text_2:
      'Ваши тексты будут проверены на ошибки в правописании, содержании и грамматике.',
    texts_and_videos_title: 'Найдите свой уровень',
    texts_and_videos_text:
      'Вы можете выбирать между простыми фразами и текстами для детей, новостями, статьями из Википедии или книгами, в зависимости от того, что вам подходит.',
    srs_title: 'Повторяйте и тренируйте словарный запас',
    srs_text_1:
      'Вы можете сохранять любое слово или целые предложения как избранное для повторения позже',
    srs_text_2:
      'Тренируйте свой словарный запас с помощью флеш-карт и простых упражнений, а также отслеживайте свой прогресс',
    srs_text_3:
      'Система повторений SRS помогает вам учить слова более эффективно, повторяя их в нужное время',
    own_text_title: 'Специализированный словарный запас',
    own_text_text:
      'Вы можете создать текст на определенную тему, чтобы изучить специализированный словарный запас. Вы также можете создавать тексты, содержащие слова, которые хотите выучить.',
    wordmap_title: 'Словесные сети',
    wordmap_text_1: 'Вы можете создавать словесные сети и связывать слова с простыми предложениями',
    wordmap_text_2:
      'Словесные карточки могут быть сохранены как избранные, что позволяет легко повторять и тренировать их',
    sayings_title: 'Идиомы',
    sayings_text:
      'Здесь вы найдете часто используемые фразы и идиомы, классифицированные по категориям. Вы можете отслеживать свой прогресс и продолжать развиваться структурированным образом.',
    details: 'Подробности',
    details_text_and_videos_title:
      'Откройте для себя Jaaluu — Ваш ключ к быстрому и эффективному изучению языков!',
    details_text_and_videos_text:
      'Jaaluu предлагает вам множество текстов и видео для улучшения вашего уровня языка. Платформа идеально подходит, если вы уже понимаете простые слова и предложения. Для новичков есть простые фразы и идиомы, тексты для детей, лексиконы и видео для легкого старта. Для продвинутых учеников — новости, статьи из Википедии, книги и интересные видео для более глубокого понимания, а также интерактивные разговоры с чат-ботом. Кроме того, вы можете тренировать правописание и получать советы по улучшению ошибок в правописании, содержании и грамматике.',
    details_click_on_words_title:
      'Изучение словарного запаса стало легче: быстро, интерактивно и эффективно!',
    details_click_on_words_text:
      'Изучение словарного запаса может быть утомительным, поскольку поиск слов и определений занимает много времени. Jaaluu решает эту проблему: просто нажмите на слово, чтобы мгновенно получить переводы, примеры предложений, определения и объяснения. Это экономит время и помогает вам учить быстрее и эффективнее!',
    details_listen_title:
      'Слушайте и практикуйте: слышите слова, предложения и тексты, чтобы улучшить свои языковые навыки!',
    details_listen_text:
      'Вы можете слушать всё — любое слово, предложение или даже целые тексты. Просто воспроизведите и слушайте! Эта функция помогает вам тренировать правильное произношение и улучшать понимание на слух. Вы также можете слушать разговоры и развивать чувство естественного общения. Отлично подходит для закрепления словарного запаса и укрепления ваших языковых навыков в повседневных ситуациях.',
    details_conversations_title:
      'Практическое языковое обучение: Реалистичные разговоры для повседневной жизни!',
    details_conversations_text:
      'С помощью Jaaluu вы можете практиковать реалистичные разговоры с чат-ботом и готовиться к типичным повседневным ситуациям. Например, вы можете заказать еду в ресторане и оплатить счет или попросить указания. Или вы можете пообщаться с новым коллегой в свой первый день на новой работе. Ваши предложения будут автоматически проанализированы, чтобы дать вам обратную связь и улучшить ваши языковые навыки. Таким образом, вы тренируетесь на практике и эффективно готовитесь к реальным разговорам!',
    details_writing_title:
      'Практика письма для повседневной жизни: улучшите свои навыки с помощью реалистичных заданий!',
    details_writing_text:
      'Вы можете практиковать письмо, осваивая небольшие, реалистичные задания, такие как написание заявлений или жалоб. Ваш текст будет автоматически проанализирован, и вы получите прямую обратную связь по правописанию, содержанию и грамматике. Так вы улучшаете свои навыки письма и готовитесь к повседневной жизни!',
    details_srs_title:
      'Эффективное изучение словарного запаса с помощью SRS: автоматические повторения и персонализированный анализ прогресса!',
    details_srs_text:
      'С системой SRS (Система интервальных повторений) вы можете эффективно учить и повторять слова. Эта система напоминает вам, когда повторить слова, чтобы сохранить их в памяти на долгий срок. SRS основана на научном методе, который утверждает, что повторение через определенные интервалы укрепляет память. Вы также получите статистику по каждому слову и вашему успеху, чтобы вы могли сосредоточиться на слабых местах и всегда знать, как хорошо вы продвигаетесь в изучении словарного запаса.',
    details_own_text_title:
      'Персонализированное обучение: создавайте собственные тексты для целенаправленных упражнений по словарному запасу и темам!',
    details_own_text_text:
      'С помощью Jaaluu вы можете легко создавать свои собственные тексты в областях, на которых хотите сосредоточиться. Опишите область или словарный запас, который вы хотите выучить, и получите текст для чтения и практики. Так вы сможете сосредоточиться на конкретных темах или словах и расширить свои знания в области, которая вам важна. Такой подход помогает учить более эффективно и точно! Кроме того, вы можете создавать тексты, содержащие весь словарный запас, который вы хотите повторить. Это позволяет вам учить и повторять слова в контексте, что облегчает их запоминание.',
    details_wordmap_title: 'Карточки слов: Связывайте свои знания и запоминайте слова с легкостью!',
    details_wordmap_text:
      'Вы можете создавать карточки слов, которые помогут вам связывать слова и запоминать их более эффективно. Добавляйте слова и предложения на карточку и постепенно расширяйте свой словарный запас. Это создает и укрепляет связи в вашем мозге и строит ассоциации в игровой форме. Таким образом, вы улучшаете понимание языка — устойчиво!',
    details_paste_text_title:
      'Используйте свои собственные тексты: вставляйте свой контент, чтобы учить с фокусом!',
    details_paste_text_text:
      'С помощью Jaaluu вы также можете вставить свои собственные тексты для использования в обучении. Это позволяет работать с вашим материалом и тренировать ваш словарный запас в реальных контекстах.',
    explore_more: 'Узнайте больше о Jaaluu',
    site_also_available: 'Сайт также доступен на',
    which_languages_title: 'Какие языки я могу выучить?',
    which_languages_text:
      'Здесь вы можете выучить английский, испанский, немецкий, французский, португальский, польский и итальянский языки. Просто выберите язык, который хотите выучить, и все готово!'
  },
  intro: {
    your_level: 'Какой у вас уровень языка?',
    beginner_explained: 'Вы можете читать простые предложения',
    intermediate_explained: 'Вы можете читать простые тексты и статьи',
    advanced_explained: 'Вы можете читать более сложные тексты',
    your_cefr_level: 'Ваш уровень CEFR:',
    lets_start: 'С чего бы вы хотели начать?',
    intermediate_options: {
      simple_texts: 'Читать тексты',
      simple_articles: 'Читать статьи',
      sayings: 'Учить выражения',
      simple_phrases: 'Читать типичные фразы',
      klexikon: 'Читать Klexikon (Детская энциклопедия)'
    },
    advanced_options: {
      news: 'Читать новости',
      wikipedia: 'Читать статьи',
      books: 'Читать книги',
      conversations: 'Практиковать разговоры',
      writing: 'Практиковать письмо'
    }
  },
  languages: {
    de: 'Немецкий',
    en: 'Английский',
    es: 'Испанский',
    fr: 'Французский',
    it: 'Итальянский',
    pt: 'Португальский',
    ru: 'Русский',
    zh: 'Китайский',
    pl: 'Польский'
  },
  general: {
    close: 'Закрыть',
    home: 'Главная',
    beginner: 'Начинающий',
    intermediate: 'Средний',
    advanced: 'Продвинутый',
    search: 'Поиск',
    what_to_read: 'Что бы вы хотели почитать?',
    search_imperative: 'Ищите',
    translate: 'Перевести',
    what_you_want_to_translate: 'Что вы хотите перевести с {from} на {to}?',
    word_not_found: 'Слово "{word}", похоже, не существует.',
    similar_words_found: 'Я нашёл самые похожие слова:',
    settings: 'Настройки',
    vocabulary: 'Словарь',
    most_important_words: '{n} самых важных слов',
    learn_most_important_words: 'Учи 500 самых важных слов',
    continue_with_word: 'Продолжить со слова {n}',
    jokes: 'Анекдоты',
    n_jokes: '{n} анекдотов',
    learn_jokes: 'Учи 200 анекдотов',
    continue_with_joke: 'Продолжить с анекдота {n}',
    shorts: 'Короткие тексты',
    articles: 'Статьи',
    feeds: 'Новости',
    videos: 'Видео',
    read: 'Читать',
    view: 'Смотреть',
    listen: 'Слушать',
    save: 'Сохранить',
    more: 'ещё',
    back: 'Назад',
    next: 'Далее',
    continue_with_sentence: 'Продолжить с предложением {sentenceIdx}',
    easy: 'Легко',
    medium: 'Средне',
    hard: 'Трудно',
    all: 'Все',
    level: 'Уровень',
    font_size: 'Размер шрифта',
    language: 'Язык',
    send: 'Отправить',
    image: 'Изображение',
    wordmap: 'Карта слов',
    open: 'Открыть',
    add: 'Добавить',
    question: 'Вопрос',
    start: 'Начать',
    continue: 'Продолжить',
    words: 'Слово | Слов',
    points: 'Очко | Очков',
    repeat: 'Повторить',
    test: 'Тестировать',
    nothing_found: 'Ничего не найдено',
    skip: 'Пропустить',
    congratulations: 'Поздравляем',
    well_done: 'Отлично!',
    try_again: 'Попробуйте снова',
    finish: 'Завершить',
    total: 'Всего',
    synapsis_score: 'Synapsis Score',
    synapsis_milestone: 'Рубеж очков синапсов! Новый счет: {score}',
    fun_facts: 'Интересные факты о {country}',
    fun_facts_missing_points: 'Очки до следующего факта о {country}',
    fun_facts_previous: 'Предыдущие факты ({count})',
    fun_fact_unlocked: 'Теперь вы можете посмотреть новый интересный факт о {country}',
    finished_units: 'Единица | Единицы',
    finished_course_chapters: 'Глава курса | Главы курса',
    grammar_chapters: 'Глава грамматики | Главы грамматики',
    completed: 'Завершено',
    turn: 'Перевернуть'
  },
  app_bar: {
    search_in_foreign_language: 'Поиск на иностранном языке',
    menu: 'Меню'
  },
  category: {
    chapter: 'Глава',
    learn_most_common_pre: 'Изучите самые распространённые',
    learn_most_common_post: 'из многих различных категорий',
    or_choose_a_category: 'Выберите категорию:',
    chapter_end: 'Вы достигли конца этой главы!',
    phrases: 'Фразы',
    sayings: 'Поговорки',
    simple_texts: 'Тексты',
    conversations: 'Разговоры',
    write: 'Письмо',
    course: 'Курс'
  },
  favorites: {
    favorites: 'Избранное',
    word: 'Слово',
    sentence: 'Предложение',
    sentences: 'Предложения',
    texts: 'Тексты',
    wordmaps: 'Карты слов',
    saved: 'Сохранено',
    title: 'Название',
    type: 'Тип',
    no_favorites_found: 'Избранное не найдено',
    filtered_by: 'отфильтровано по',
    train: 'Тренировка',
    train_words: 'Тренировать {wordCount} слова',
    notify_me_srs: 'Уведомить меня, чтобы повторить словарный запас с помощью SRS',
    action_sounds: 'Звуки действий',
    srs_level: 'Уровень SRS',
    success_rate: 'Процент успешности',
    word_type: 'Часть речи',
    translation: 'Перевод',
    context: 'Контекст',
    last_seen: 'В последний раз видели',
    next_review: 'Следующий просмотр',
    short_story: 'Короткий рассказ',
    success_level_up: 'Слово перемещено на уровень {level}',
    success_level_up_celebrate: 'Слово {word} перешло на следующий уровень!',
    what_is_srs: 'Что такое SRS?',
    srs_short:
      'SRS — это система интервальных повторений. Она помогает вам лучше запоминать слова, повторяя их в нужное время.',
    srs_long:
      'Система основана на принципе, что чем чаще вы повторяете слово, тем лучше вы его запоминаете. Интервалы между повторениями определяются системой. Если вы хорошо запомнили слово, интервалы становятся длиннее. Если у вас возникают трудности, интервалы становятся короче. Так вы можете учить слова более эффективно.',
    srs_intervals: 'Интервалы повторений: {nIntervals} дня(ей): {intervals} дней.',
    when_does_a_word_move: 'Когда слово переходит на следующий уровень?',
    srs_next_level_example_1:
      'Если вы добавите слово в избранное, оно будет на уровне 1. Слово на уровне 1 перейдет на следующий уровень, если пройдет 1 день с момента добавления слова, ваш процент успешности будет выше 50% и вы только что правильно запомнили это слово.',
    srs_next_level_example_2:
      'Слово на уровне {level} перейдет на следующий уровень, если последний переход на уровень {levelM1} был не менее {days} дней назад, ваш процент успешности будет выше 50% и вы только что правильно запомнили это слово.',
    favorite_group: 'Gruppe',
    group_already_exists: 'Папка с таким именем уже существует',
    cannot_delete_default: 'Папку `Default` нельзя удалить',
    group_still_has_words:
      'Папка все еще содержит избранное. Пожалуйста, сначала удалите все избранное.',
    group_deleted: 'Папка удалена'
  },
  player: {
    maximize: 'Развернуть',
    minimize: 'Свернуть'
  },
  video: {
    error:
      'Произошла ошибка при загрузке субтитров. К сожалению, не все субтитры доступны бесплатно. Пожалуйста, попробуйте другое видео.'
  },
  feeds: {
    disclaimer:
      'Это автоматически сгенерированное резюме с помощью ChatGPT. Оригинальная статья доступна',
    here: 'здесь',
    generating_article: 'Генерация статьи...',
    error:
      'Произошла ошибка при загрузке статьи. К сожалению, не все статьи доступны бесплатно. Пожалуйста, попробуйте другую статью или скопируйте текст вручную',
    open_org: '1. Откройте оригинальную статью и скопируйте текст',
    open_own: '2. Вставьте текст сюда'
  },
  books: {
    read_now: 'Читать сейчас',
    continue_on_page: 'Продолжить на странице'
  },
  tooltip: {
    examples: 'Примеры',
    emotional_examples: 'Эмоциональные примеры',
    definition: 'Определение',
    base_word: 'Начальная форма',
    synonyms: 'Синонимы',
    antonyms: 'Антонимы',
    article: 'Артикль',
    conjugations: 'Спряжение',
    grammer: 'Грамматика',
    etymology: 'Этимология',
    all_meanings: 'Все значения',
    context: 'Контекст'
  },
  custom_text: {
    enter_your_own_text: 'Введите ваш текст',
    read_text: 'Читать текст',
    enter_new_text: 'Введите новый текст',
    own_text: 'Скопируйте свой текст и вставьте его сюда',
    special_vocabulary: 'Специальная лексика'
  },
  special_vocabulary: {
    special_vocabulary: 'Специальный словарь',
    explanation:
      'Здесь вы можете создать новый текст на тему, которую хотите изучить. Будет сгенерирован текст, который вы сможете использовать для обучения.',
    describe:
      'Введите текст на английском языке по теме или специальному словарному запасу, который вы хотите выучить',
    language_level: 'Уровень языка',
    generate_text: 'Сгенерировать текст'
  },
  custom_vocabulary: {
    custom_vocabulary: 'Собственный словарь',
    add_new_category: 'Добавить новую категорию',
    title: 'Название',
    description: 'Какой словарный запас вы хотите выучить?',
    description_placeholder: 'Опишите словарный запас, который вы хотите выучить',
    description_example: 'Например: «Числа от 1 до 20»',
    number_of_words: 'Количество слов',
    generate: 'Сгенерировать',
    no_lists_found: 'Пока нет собственных списков словаря',
    list_not_found: 'Этот список словаря не найден',
    error_generating: 'Произошла ошибка при генерации словаря. Попробуйте еще раз.',
    home_teaser: 'Создавайте собственные списки слов на любую тему, которую хотите выучить',
    n_lists: 'собственный список | собственных списков'
  },
  live_conversations: {
    start_conversation: 'Начать разговор',
    end_conversation: 'Завершить разговор',
    connecting: 'Подключение…',
    connected: 'Разговор идёт…',
    microphone_error:
      'Не удалось начать разговор. Проверьте доступ к микрофону и попробуйте снова.',
    not_found: 'Этот разговор не найден',
    reviewing: 'Проверяем ваш разговор…',
    transcript_title: 'Ваш разговор',
    no_turns: 'Разговор не был записан.',
    no_mistakes: 'Ошибок не найдено — отлично!',
    review_unavailable: 'Не удалось загрузить разбор. Попробуйте позже.'
  },
  intro_message: {
    save_word_as_fav: 'Нажмите на звезду, чтобы сохранить слово в избранное',
    save_video_as_fav: 'Нажмите на звезду, чтобы сохранить видео в избранное',
    save_article_as_fav: 'Нажмите на звезду, чтобы сохранить статью в избранное',
    save_book_as_fav: 'Нажмите на звезду, чтобы сохранить книгу в избранное',
    save_wordmap_as_fav: 'Нажмите на звезду, чтобы сохранить карту слов в избранное',
    play_word: 'Нажмите на кнопку воспроизведения, чтобы послушать произношение слова',
    play_article: 'Нажмите на кнопку воспроизведения, чтобы послушать статью',
    play_book: 'Нажмите на кнопку воспроизведения, чтобы послушать книгу',
    select_main_category: 'Выберите главную категорию',
    select_sub_category: 'Выберите подкатегорию',
    click_on_read: 'Нажмите «ЧИТАТЬ», чтобы прочитать весь текст',
    click_on_view: 'Нажмите «СМОТРЕТЬ», чтобы посмотреть видео',
    wordmap_click_on_word: 'Нажмите на слово, чтобы увидеть наиболее часто используемые слова',
    wordmap_click_on_line: 'Нажмите на линию между двумя словами, чтобы увидеть предложение',
    conversations_select_scene: 'Выберите упражнение',
    conversations_warn:
      'Кажется, в вашем предложении ошибка. Нажмите на треугольник для получения дополнительных объяснений.',
    conversations_task: 'Сформулируйте предложение на основе следующих инструкций:'
  },
  tour_guide: {
    click_on_every_word: {
      title: 'Перевод слова',
      text: 'Вы можете нажать на любое слово, чтобы увидеть переводы, примеры и определения'
    },
    click_on_i_for_sentence: {
      title: 'Целое предложение',
      text: 'Чтобы перевести целое предложение, нажмите на значок i. Здесь вы также можете получить разъяснения по грамматике.'
    },
    no_save_custom: {
      title: 'Нет сохранения',
      text: 'Собственные тексты не могут быть сохранены'
    },
    change_playback_rate: {
      title: 'Изменить скорость воспроизведения',
      text: 'Измените скорость воспроизведения в Меню/Настройки/Аудио и Видео.'
    },
    theme: {
      title: 'Цвета',
      text: 'Вы можете изменить цвета в меню на тёмный режим'
    },
    repeat_words: {
      title: 'Повторить словарный запас',
      text: 'Вам нужно повторить {nWords} слов.',
      call_to_action: 'Учить сейчас'
    },
    flipcards: {
      title: 'Карточки',
      text: 'Переверните карточку и нажмите на весёлое или грустное лицо, чтобы отслеживать свой прогресс'
    },
    synapsis_score: {
      title: 'Очки Synapsis',
      text: 'Вы зарабатываете очки за каждое слово, взвешенные по его уровню, и дополнительные очки за каждую завершенную главу или единицу'
    }
  },
  chat: {
    your_message: 'Ваше сообщение',
    waiting_for_teacher: 'Ожидание учителя...',
    in_de: 'на немецком',
    in_en: 'на английском',
    in_es: 'на испанском',
    in_fr: 'на французском',
    in_it: 'на итальянском',
    in_pt: 'на португальском',
    in_ru: 'на русском',
    in_zh: 'на китайском',
    in_pl: 'на польском',
    wait: 'Пожалуйста, подождите...',
    speak_now: 'Говорите сейчас',
    new_chat: 'Новый чат',
    switch_language: 'Сменить язык',
    language_teacher: 'Учитель языка',
    summarize_mistakes: 'Суммировать ошибки'
  },
  langs: {
    de: 'Немецкий',
    en: 'Английский',
    sp: 'Испанский',
    fr: 'Французский',
    it: 'Итальянский',
    pt: 'Португальский',
    pl: 'Польский',
    ru: 'Русский',
    zh: 'Китайский'
  },
  countries: {
    de: 'Германия',
    en: 'Англия',
    es: 'Испания',
    fr: 'Франция',
    it: 'Италия',
    pt: 'Португалия',
    pl: 'Польша',
    ru: 'Россия',
    zh: 'Китай'
  },
  about: {
    how_does_it_work: 'Как это работает?',
    here_you_can: 'Здесь вы можете',
    read_texts: 'Читать тексты',
    watch_videos: 'Смотреть видео',
    click_on_every_wrord_for: 'Нажимайте на любое слово для',
    translations: 'переводов',
    examples: 'примеров',
    definitions: 'определений',
    synonyms: 'синонимов',
    copy_your_own_text: 'Копировать и читать свой текст',
    chat_with_chatbot: 'Общаться с чат-ботом',
    level: 'Ваш уровень должен быть между B1 и C2'
  },
  settings: {
    audio_video: 'Аудио и Видео',
    level: 'Уровень',
    colors: 'Цвета',
    dark_mode: 'Темный режим',
    lang_level: 'Уровень языка',
    show_pinyin: 'Показать пиньинь',
    show_translation: 'Показать перевод'
  },
  error: {
    resource_not_found: 'Извините, мы не смогли найти то, что вы ищете'
  },
  train: {
    check: 'Проверить',
    flashcards: 'Флеш-карты',
    exercises: 'Упражнения',
    finished: 'Упражнения завершены',
    go_to_favorites: 'Перейти в избранное',
    restart_exercise: 'Перезапустить упражнение',
    go_to_home: 'Перейти на главную',
    text_with_words: 'Текст с словами',
    text_includes: 'Текст включает все слова, которые вы хотите выучить',
    generate_audio: 'Создать аудио',
    stop_audio: 'Остановить аудио'
  },
  wordmap: {
    click_on_circle: 'Нажмите на круг, чтобы увидеть наиболее часто используемые слова с {word}',
    click_on_edge:
      'Нажмите на линию между двумя словами, чтобы увидеть предложение с обоими словами',
    open_fullscreen: 'Открыть на весь экран',
    add_own_word: 'Добавить свое слово',
    add_sentence_with_all_words: 'Добавить предложение со всеми словами',
    add_to_word: 'Добавить в слово'
  },
  conversations: {
    you_are: 'Вы',
    you_talk_to: 'Вы говорите с',
    your_tasks: 'Ваши задачи'
  },
  write: {
    min_words: 'Минимальное количество слов',
    your_email_needs_to_contain: 'Ваш email должен содержать',
    rate: 'Оценка',
    analysis: 'Анализ',
    overall: 'Общее',
    grammar: 'Грамматика',
    content: 'Содержание',
    spelling: 'Орфография',
    passed: 'Отличная работа! Вы прошли это упражнение.',
    failed: 'Продолжайте практиковаться! Вашего балла недостаточно для прохождения.',
    restart: 'Попробовать снова'
  },
  cookies: {
    title: 'This website uses cookies',
    description:
      "We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services.",
    description_short:
      'We use cookies to personalise content and ads, to provide social media features and to analyse our traffic...',
    deny: 'Deny',
    allow_selection: 'Allow selection',
    clear_local_storage: 'Clear local storage keys',
    clear_local_storage_confirm: 'Are you sure you want to remove selected local storage keys?',
    clear_local_storage_success: 'Selected local storage keys have been removed.',
    tooltip_necessary:
      'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
    tooltip_preferences:
      'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.',
    tooltip_statistics:
      'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
    tooltip_marketing:
      'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.'
  },
  grammar: {
    start_grammar_lessons: 'Начать уроки грамматики'
  },
  transcription: {
    title: 'Живая транскрипция',
    subtitle: 'Слушайте разговор и видите его в виде текста на экране',
    start: 'Начать транскрипцию',
    stop: 'Стоп',
    listening: 'Слушаю…',
    transcribing: 'Транскрибирую…',
    mic_settings_title: 'Настройки микрофона',
    mic_mode_close: 'Речь рядом',
    mic_mode_distant: 'Издалека / воспроизведение',
    mic_boost_label: 'Усиление микрофона',
    mic_settings_hint: 'Применится при следующем запуске',
    mic_level_label: 'Уровень входного сигнала микрофона',
    mic_level_clipping: 'Слишком громко',
    mic_test_start: 'Проверить микрофон',
    mic_test_stop: 'Остановить проверку',
    empty_state: 'Нажмите «Начать транскрипцию» и начните говорить — сказанное появится здесь',
    not_supported:
      'Живая транскрипция не поддерживается в этом браузере. Убедитесь, что доступ к микрофону включён.',
    microphone_error:
      'Не удалось получить доступ к микрофону. Проверьте разрешения микрофона и попробуйте снова.',
    transcription_error: 'Не удалось расшифровать этот фрагмент. Продолжаю слушать…',
    copied: 'Транскрипция скопирована в буфер обмена'
  },
  video_object_detection: {
    title: 'Распознавание Объектов на Видео',
    subtitle:
      'Наведите камеру на предметы вокруг себя и узнайте, как они называются на изучаемом языке',
    start: 'Начать Видео',
    stop: 'Стоп',
    scanning: 'Сканирование…',
    empty_state:
      'Нажмите «Начать Видео» и наведите камеру на предметы, чтобы увидеть их названия здесь',
    not_supported: 'Доступ к камере не поддерживается в этом браузере. Попробуйте Chrome или Edge.',
    camera_error:
      'Не удалось получить доступ к камере. Проверьте разрешения камеры и попробуйте снова.',
    detected_words: 'Обнаруженные слова',
    nearby_objects: 'Другие объекты поблизости — нажмите, чтобы добавить'
  }
};
